import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';

import { MaterialCommonModule } from 'src/app/material-modules/material-common.module';
import { DadosUnidadeModule } from '../common/dados-unidade/dados-unidade.module';
import { CadastrarFrequenciaAlunoUnidadeComponent } from './cadastrar-frequencia-aluno-unidade/cadastrar-frequencia-aluno-unidade.component';
import { FrequenciaAlunoUnidadeRoutingModule } from './frequencia-aluno-unidade-routing.module';
import { FrequenciaAlunoUnidadeComponent } from './frequencia-aluno-unidade.component';


@NgModule({
  declarations: [FrequenciaAlunoUnidadeComponent, CadastrarFrequenciaAlunoUnidadeComponent],
  imports: [
    CommonModule,
    FrequenciaAlunoUnidadeRoutingModule,
    DadosUnidadeModule,
    MaterialCommonModule
  ]
})
export class FrequenciaAlunoUnidadeModule { }
